<template><ProductDetailBase route-key="/products/330-400kv" /></template>
<script>
import ProductDetailBase from "./ProductDetailBase.vue";
export default { name: "Product400Page", components: { ProductDetailBase } };
</script>
